/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GroupOutputDto { 
    id?: number;
    groupOwnerMemberId?: number;
    membersCount?: number;
    ownerName?: string | null;
    ownerEmail?: string | null;
    status?: string | null;
}

